import axios from "axios";
import * as Config from "./config";

async function reqImageLinksFooter(token) {
  const API_URL_IMAGE_LINKS_FOOTER = Config.footerRoute.imageLinksFooterRoute;
  try {
    const response = await axios.get(API_URL_IMAGE_LINKS_FOOTER, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqTextLinksFooter(token) {
  const API_URL_TEXT_LINKS_FOOTER = Config.footerRoute.textLinksFooterRoute;
  try {
    const response = await axios.get(API_URL_TEXT_LINKS_FOOTER, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqLogoSitioWebFooter(token) {
  const API_URL_LOGO_SITIO_WEB = Config.footerRoute.logoSitioWebRoute;
  const response = await axios.get(API_URL_LOGO_SITIO_WEB, {
    headers: { Authorization: "Bearer " + token },
  });
  return response.data;
}

//eslint-disable-next-line
export default {
  reqImageLinksFooter,
  reqTextLinksFooter,
  reqLogoSitioWebFooter
};
